module.exports = __webpack_public_path__ + "img/Visa Logo.c73a8473.svg";